import { BootstrapWebScreen, ErrorScreen } from "@dynamynd/dynamynd";
import { RoutesKeysEnum } from "@dynamynd/routes";
import {
    authNavigator,
    modulesNavigator,
    sharedNavigator,
    surveyNavigator,
    userNavigator,
} from "../navigators";
import { ContactNavigator } from "../navigators/contact.navigator";
import { HomeNavigator } from "../navigators/home.navigator";

export const routes = {
    [RoutesKeysEnum.bootstrap]: BootstrapWebScreen,
    [RoutesKeysEnum.home]: HomeNavigator,
    [RoutesKeysEnum.contact]: ContactNavigator,
    [RoutesKeysEnum.shared]: sharedNavigator,
    [RoutesKeysEnum.auth]: authNavigator,
    [RoutesKeysEnum.survey]: surveyNavigator,
    [RoutesKeysEnum.modules]: modulesNavigator,
    [RoutesKeysEnum.user]: userNavigator,
    [RoutesKeysEnum.error]: ErrorScreen,
};
